// JsFromRoutes CacheKey 815d8213861a21bd33233f76f6c48d89
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/content/list_view'),
}
